<!--
Copyright (c) 2025-2026, NVIDIA CORPORATION.  All rights reserved.

NVIDIA CORPORATION and its licensors retain all intellectual property
and proprietary rights in and to this software, related documentation
and any modifications thereto.  Any use, reproduction, disclosure or
distribution of this software and related documentation without an express
license agreement from NVIDIA CORPORATION is strictly prohibited.
-->
<div
    class="tab-container"
    role="tablist"
    [class.fixed-width-tab-container]="fixedWidth"
    #tabContainer
    nvSpatialNavigationContainer
    [containFocus]="false"
    [captureFocusForChild]="true"
>
    @if (!fixedWidth) {
        <div class="tab-container-spacer"></div>
    }
    @for (item of tabItems; track $index) {
        <button
            mat-button
            class="tab-button"
            [class.selected-tab]="item.text === currentSelectedItem?.text"
            [class.tabs-without-icon]="!item.svgIconId"
            (click)="onItemClick($event, item.type)"
            role="tab"
            [attr.aria-selected]="item.text === currentSelectedItem?.text"
        >
            <div class="tab-label">
                @if (item.svgIconId) {
                    <mat-icon [svgIcon]="item.svgIconId"></mat-icon>
                }
                <span
                    class="font-sub2"
                    [class.font-color-primary]="item.text === currentSelectedItem?.text"
                    [class.font-color-secondary]="item.text !== currentSelectedItem?.text"
                    >{{ item.text | translate }}</span
                >
            </div>
        </button>
    }
    @if (!fixedWidth) {
        <div class="tab-container-spacer"></div>
    }
</div>
